// HQ Display Group相关常量

// 状态选项生成函数
export const getStatusOptions = (t: (key: string) => string) => [
  { value: 'all', label: t('hqDisplayGroup.status.all') },
  { value: 'ENABLE', label: t('hqDisplayGroup.status.active') },
  { value: 'DISABLE', label: t('hqDisplayGroup.status.inactive') },
];

// 向后兼容的静态常量（已废弃，建议使用 getStatusOptions）
export const STATUS_OPTIONS = [
  { value: 'all', label: '全部' },
  { value: 'ENABLE', label: '激活' },
  { value: 'DISABLE', label: '停用' },
  { value: 'Pending', label: '待审核' },
  { value: 'DRAFT', label: '草稿' },
];

// 向后兼容的别名（已废弃，建议使用 getStatusOptions）
export const DISPLAY_GROUP_STATUS_OPTIONS = STATUS_OPTIONS;

// 状态颜色
export const DISPLAY_GROUP_STATUS_COLORS = {
  ENABLE: '#52c41a',
  DISABLE: '#ff4d4f',
  PENDING: '#faad14',
  DRAFT: '#999',
};

// 状态标签生成函数（支持国际化）
export const getStatusLabel = (status: string, t: (key: string) => string): string => {
  const statusMap: Record<string, string> = {
    'ENABLE': t('hqDisplayGroup.status.active'),
    'DISABLE': t('hqDisplayGroup.status.inactive'),
    'Pending': t('hqDisplayGroup.status.pending'),
    'DRAFT': t('hqDisplayGroup.status.draft'), // DRAFT映射为草稿状态
  };
  return statusMap[status] || status;
};

// 状态标签（已废弃，建议使用 getStatusLabel）
export const DISPLAY_GROUP_STATUS_LABELS = {
  ENABLE: '激活',
  DISABLE: '停用',
  PENDING: '审核中',
  DRAFT: '草稿',
};
